import produce from 'immer';
import { SET_CLEAR_CUSTOMER } from 'containers/WorkQueue/constants';
import {
  SET_ROLE_TYPES,
  SET_BP_TYPES,
  SET_TITLES,
  SET_BP_COUNTRY,
  SET_STATE,
  SET_CIPVERIFICATIONTYPES,
  SET_STATEOFISSUANCE,
  SET_FEEDAGENCYOFISSUANCE,
  SET_MLTRYAGENCYOFISSUANCE,
  SET_INVOLVED_PARTIES_ERROR,
} from 'containers/InvolvedParties/constants';
import { SET_INVOLVED_PARTIES } from './constants';

export const initialState = {
  involvedParties: { data: [] },
  roleTypeList: [],
  bpTypeList: [],
  titleList: [],
  state: [],
  country: [],
  cipVerificationTypes: [],
  stateOfIssuance: [],
  feedAgencyOfIssuance: [],
  mltryAgencyOfIssuance: [],
  errorInfo: {},
};

const reducer = (state = initialState, { type, payload }: any) =>
  produce(state, (draft: any) => {
    switch (type) {
      case SET_INVOLVED_PARTIES:
        draft.involvedParties = payload;
        break;
      case SET_CLEAR_CUSTOMER:
        draft.involvedParties = initialState.involvedParties;
        break;
      case SET_ROLE_TYPES:
        draft.roleTypeList = payload;
        break;
      case SET_BP_TYPES:
        draft.bpTypeList = payload;
        break;
      case SET_TITLES:
        draft.titleList = payload;
        break;
      case SET_STATE:
        draft.state = payload;
        break;
      case SET_BP_COUNTRY:
        draft.country = payload;
        break;
      case SET_CIPVERIFICATIONTYPES:
        draft.cipVerificationTypes = payload;
        break;
      case SET_STATEOFISSUANCE:
        draft.stateOfIssuance = payload;
        break;
      case SET_FEEDAGENCYOFISSUANCE:
        draft.feedAgencyOfIssuance = payload;
        break;
      case SET_MLTRYAGENCYOFISSUANCE:
        draft.mltryAgencyOfIssuance = payload;
        break;
      case SET_INVOLVED_PARTIES_ERROR:
        draft.errorInfo = payload;
        break;
      default: {
        break;
      }
    }
  });

export default reducer;
